export const API_GET_LIST_PROPERTY = "api/property/site/list";
export const API_DELETE_PROPERTY = "api/property/form/delete";
export const API_UPDATED_PROPERTY = "api/property/form/update";
export const API_CREATED_PROPERTY = "api/property/form/create";
export const API_VIEW_PROPERTY = "api/property/site/detail";
export const API_CREATE_MANY_PRODUCT_PROPERTY = "/api/product_property/form/save-many";
export const API_GET_PROPERTY_GROUP = "api/product_property/site/group-property";